
import React from 'react';
import { TableRow, TableCell } from '@/components/ui/table';

interface UserTableEmptyProps {
  hasSearchQuery: boolean;
}

export const UserTableEmpty: React.FC<UserTableEmptyProps> = ({
  hasSearchQuery
}) => {
  return (
    <TableRow>
      <TableCell colSpan={6} className="text-center py-8">
        <p className="text-muted-foreground">No users found</p>
        {hasSearchQuery && (
          <p className="text-sm text-muted-foreground mt-1">
            Try adjusting your search criteria
          </p>
        )}
      </TableCell>
    </TableRow>
  );
};
